export default __webpack_public_path__ + "9c4a113eb33b2cbb04c65567754f005d.svg";